import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translation, enumtranslate } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'
import InspectionItem from '../InspectionItem'

// Elements
import Radio from '../../../../shared/elements/radio'
import Text from '../../../../shared/elements/text'
import Divider from '../../../../shared/elements/divider'
import LabelWrapper from '../../../../shared/elements/labelWrapper'

class Claim extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderContent = this.renderContent.bind(this)
  }

  componentDidMount () {
  }
  renderContent () {
    let Claim = this.props.claim
    if (Claim === null) return null
    let ourName = translation('733')
    let shopName = this.props.shopName
    let custName = this.props.customerName
    if (shopName) {
      ourName = shopName
    }
    let customerName = translation('363')
    if (custName) {
      customerName = custName
    }
    const onBlur = (e) => {
      this.props.onBlur(e)
    }
    const onChange = (e) => {
      this.props.onChange(e)
    }
    const renderReason = (item, key) => {
      const renderComplaint = (complaint, k) => {
        let complaintName = enumtranslate('ComplaintTypes', complaint)
        if (this.props.isBodyshop) {
          switch (complaint) {
            case 14: complaintName = 317
              break
            case 15: complaintName = 318
              break
            case 16: complaintName = 320
              break
            case 17: complaintName = 319
              break
            case 18: complaintName = 321
              break
            case 19: complaintName = 322
              break
            case 20: complaintName = 227
              break
            case 26: complaintName = 766
              break
            case 27: complaintName = 767
              break
            case 28: complaintName = 770
              break
            case 1026: complaintName = 1034
              break
            case 1027: complaintName = 1307
              break
          }
        }
        return (
          <div key={k} className='reason'>
            {translation(complaintName)}
          </div>
        )
      }
      let side = ''
      if (item.Part.TaskSide !== 0) {
        side = (item.Part.TaskSide === 1) ? translation('213') : translation('214')
      }
      return (
        <LabelWrapper labelText={side + translation(item.Part.DictionaryKey)} key={key}>
          {item.Complaints.map(renderComplaint)}
        </LabelWrapper>
      )
    }
    return (
      <div>
        <Text labelText={translation('13410')} name='ComplaintOurRefNr' value={Claim.ComplaintOurRefNr || ''} onChange={onChange} onBlur={onBlur} />
        <Text labelText={translation('185')} defaultValue={Claim.ComplaintCustomerRef || ''} disabled />
        <div className='category'>
          <h3>{translation('333')}</h3>
          <Divider />
          {Claim.ComplaintReasons.map(renderReason)}
        </div>
        <div className='category'>
          <h3>{translation('994')}</h3>
          <Divider />
          {Claim.ComplaintComment}
        </div>
        <div className='category'>
          <h3>{translation('13409')}</h3>
          <Divider />
          {Claim.PreviousOrder !== null ? (
            <div>
              {renderFullDate(Claim.PreviousOrder.Delivery, false)}, <a target='_blank' href={'/orders/' + Claim.PreviousOrder.OrderId}>
                {Claim.PreviousOrder.OrderId}
              </a>
            </div>) : (
              <div>
                {translation('2004')}
              </div>
          )}
        </div>
        <div className='category'>
          <LabelWrapper labelText={translation('1427')}>
            <Radio labelText={ourName} id='payment_us' name='Payment' value='us' checked={Claim.ComplaintPayer === 1} onChange={onChange} />
            <Radio labelText={customerName} id='payment_customer' name='Payment' value='customer' checked={Claim.ComplaintPayer === 0} onChange={onChange} />
          </LabelWrapper>
        </div>
        {Claim.ComplaintPayer === 0 && (
          <Text labelText={translation('641')} name='ComplaintPrice' value={Claim.ComplaintPrice || 0} onChange={onChange} onBlur={onBlur} />
        )}
      </div>
    )
  }
  render () {
    if (!this.props.claim) return null
    let title = {
      icon: '/images/svgs/inspection/complaint-black.svg',
      text: '301'
    }
    const headerClick = () => {
      let prop = 'Claim'
      if (this.props.isBodyshop) prop = 'BodyshopClaim'
      this.props.onHeaderClick(prop)
    }
    return (
      <InspectionItem title={title} renderContent={this.renderContent} onHeaderClick={headerClick} checked={this.props.claim.Checked} />
    )
  }
}

Claim.defaultProps = {
  isBodyshop: false
}

Claim.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  claim: PropTypes.object.isRequired,
  onHeaderClick: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

Claim.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(Claim)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/Claim/index.js